<template>
  <div>
    <form id="calculatorForm" v-on:change="calculate">
      <b-container class="p-0">
        <b-form id="form" v-if="!showSendForm">
          <!-- TITEL-RADEN -->
          <b-row class="pt-3 pb-3">
            <b-col class="mr-auto" cols="12" md="auto" lg="7">
              <h3 id="title">How much could you save with the MIG?</h3>
              <!--<p>Using the GrabiQ Midgrab shortener, and shortening down by the hook and removing the need to lower the entire assembly down to working height you can save significant amounts of time and money compared to traditional, top shortening systems. How much time and money can you save your worksite?</p>-->
              <p>The GrabiQ Mid Grab shortener removes the need to lower the entire assembly to working height. By shortening the chain down by the hook, you can save significant amounts of time and money compared to traditional, top shortening systems.</p>
            </b-col>
            <b-col class="pr-2 ml-auto ml-md-0 mb-2 mb-md-1 pt-1 align-self-md-end" cols="2" md="auto">
              <span id="metric" v-bind:style="{ color: colorMetric }">Metric</span>
            </b-col>
            <b-col class="pr-0 pt-1 mb-2 mb-md-1 align-self-md-end" cols="2" md="auto">
              <div class="switch-component-wrapper" @click="changeSwitchValue">
                <div class="switch-wrapper" :class="{ on: choice, off: !choice }">
                  <div class="circle"></div>
                </div>
              </div>
            </b-col>
            <b-col class="mr-0 mr-auto mr-md-0 mb-2 mb-md-1 pt-1 align-self-md-end" cols="2" md="auto">
              <span id="imperial" v-bind:style="{ color: colorImperial }">Imperial</span>
            </b-col>
            <b-col class="mr-3 align-self-md-end" cols="12" md="2">
              <b-form-select id="selectC" v-model="selected" :options="currencyOptions"></b-form-select>
            </b-col>
          </b-row>

          <!-- CRANE INFO KOLUMNEN -->
          <div class="px-3">
            <b-row>
              <b-col id="craneInfo" class="column mr-3 p-3" cols="12" md>
                <b-form-group>
                  <h4>Crane info</h4>
                  <b-form-group label-cols-sm="8" :label="maxLabel" label-for="maxLineInput">
                    <b-col class="p-0">
                      <b-form-input
                        class="rounded-pill formFocus"
                        id="maxLineInput"
                        v-model="maxLineInput"
                        type="number"
                        placeholder="-"
                      ></b-form-input>
                    </b-col>
                  </b-form-group>

                  <p class="text-center" id="or">
                    <span>or</span>
                  </p>

                  <p class="text-muted">If you don’t know the winch line speed you can use 350 ft/min or 100 m/min</p>

                  <b-form-group label-cols-sm="8" :label="winchLabel" label-for="winchLS">
                    <b-col class="p-0">
                      <b-form-input
                        class="rounded-pill"
                        id="winchLS"
                        v-model="winchLineSpeed"
                        type="number"
                        v-bind:readonly="winch_readonly"
                        placeholder="-"
                      ></b-form-input>
                    </b-col>
                  </b-form-group>

                  <b-form-group label-cols-sm="8" label="Sheaves reeved:" label-for="sheavesR">
                    <b-col class="p-0">
                      <b-form-input
                        class="rounded-pill"
                        id="sheavesR"
                        v-model="sheavesReeved"
                        type="number"
                        v-bind:readonly="sheaves_readonly"
                        placeholder="-"
                      ></b-form-input>
                    </b-col>
                  </b-form-group>
                </b-form-group>
              </b-col>

              <!-- COST INFO KOLUMNEN -->
              <b-col id="costInfo" class="column mr-3 p-3" cols="12" md>
                <b-form-group>
                  <h4>Cost info</h4>
                  <b-form-group label-cols-sm="8" label="Crane cost per hour:" label-for="craneC">
                    <b-col class="p-0">
                      <b-form-input
                        class="rounded-pill"
                        id="craneC"
                        v-model="craneCost"
                        type="number"
                        placeholder="-"
                      ></b-form-input>
                    </b-col>
                  </b-form-group>
                  <b-form-group label-cols-sm="8" label="Labor cost per hour:" label-for="laborC">
                    <b-col class="p-0">
                      <b-form-input
                        class="rounded-pill"
                        id="laborC"
                        v-model="laborCost"
                        type="number"
                        placeholder="-"
                      ></b-form-input>
                    </b-col>
                  </b-form-group>

                  <b-form-group label-cols-sm="8" label="Other cost per hour:" label-for="otherC">
                    <b-col class="p-0">
                      <b-form-input
                        class="rounded-pill"
                        id="otherC"
                        v-model="otherCost"
                        type="number"
                        placeholder="-"
                      ></b-form-input>
                    </b-col>
                  </b-form-group>

                  <!-- TOTAL COST PER HOUR RESULTAT, I COST INFO KOLUMNEN -->
                  <b-row v-if="showTotal">
                    <b-col
                      cols="6"
                      class="totalCost blue"
                      v-bind:style="{ 'font-size': fontSizeTotal }"
                    >
                      <p>Total cost per hour:</p>
                    </b-col>
                    <b-col
                      cols="6"
                      class="text-right"
                      v-bind:style="{ 'font-size': fontSizeTotal }"
                    >
                      <b class="mr-1">{{ selected }}</b>
                      <b class="mr-2">{{ cph }}</b>
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-col>

              <!-- LIFT INFO KOLUMNEN -->
              <b-col class="column p-3" cols="12" md>
                <b-form-group>
                  <h4>Lift info</h4>
                  <b-form-group label-cols-sm="8" :label="slingLabel" label-for="slingL">
                    <b-col class="p-0">
                      <b-form-input
                        class="rounded-pill"
                        id="slingL"
                        v-model="slingLength"
                        type="number"
                        placeholder="-"
                      ></b-form-input>
                    </b-col>
                  </b-form-group>

                  <b-form-group label-cols-sm="8" label="Nr of Adjustments needed:" label-for="adj">
                    <b-col class="p-0">
                      <b-form-input
                        class="rounded-pill"
                        id="adj"
                        v-model="adjustments"
                        type="number"
                        placeholder="-"
                      ></b-form-input>
                    </b-col>
                  </b-form-group>

                  <b-form-group label-cols-sm="8" label="Lifts per day:" label-for="lifts">
                    <b-col class="p-0">
                      <b-form-input
                        class="rounded-pill"
                        id="lifts"
                        v-model="lifts"
                        type="number"
                        placeholder="-"
                      ></b-form-input>
                    </b-col>
                  </b-form-group>
                </b-form-group>
              </b-col>
            </b-row>
            <br />

            <!-- RESULTATET -->
            <b-row v-if="showResult">
              <b-col class cols="0" md="10">
                <b-row>
                  <b-col class="column mr-3 p-2 d-none d-md-block" cols="12" md>
                    <h4 class="blue titleResult">Estimated savings per lift</h4>
                  </b-col>
                  <b-col class="column mr-3 p-2 d-none d-md-block">
                    <h4 class="blue titleResult">Estimated savings per day</h4>
                  </b-col>
                </b-row>

                <b-row class="h-60">
                  <b-col class="d-md-none column pt-3">
                      <h4 class="blue titleResult text-center">Estimated savings per lift</h4>
                  </b-col>

                  <b-col class="column text-center mr-1 pb-1" id="resultColumn" cols="12" md>
                    <h1 class="mt-4" v-bind:style="{ 'font-size': fontS }">{{ timeSavedLift }}</h1>
                    <p class="blue">minutes</p>
                  </b-col>

                  <b-col class="column text-center mr-3 pb-1" cols="12" md>
                    <h1 class="mt-4" v-bind:style="{ 'font-size': fontS }">{{ costSavedLift }}</h1>
                    <p class="blue">{{ selected }}</p>
                  </b-col>

                  <b-col class="d-md-none column pt-3 mt-3">
                      <h4 class="blue titleResult text-center">Estimated savings per day</h4>
                  </b-col>

                  <b-col class="column text-center mr-1 pb-1" cols="12" md>
                    <h1 class="mt-4" v-bind:style="{ 'font-size': fontS }">{{ timeSavedDay }}</h1>
                    <p class="blue">hours</p>
                  </b-col>

                  <b-col class="column text-center mr-3 pb-1" cols="12" md>
                    <h1 class="mt-4" v-bind:style="{ 'font-size': fontS }">{{ costSavedDay }}</h1>
                    <p class="blue">{{ selected }}</p>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col class="column mr-3 pb-4" id="empty" cols="12" md></b-col>
                  <b-col class="column mr-3"></b-col>
                </b-row>
              </b-col>

              <!-- KNAPPARNA -->
              <b-col class="px-0">
                <b-button class="rounded-0 mb-3 py-3" id="resetButton" @click="resetForm">
                  <svgicon class="mb-2" id="resetIcon" icon="ico_reset" color="#0492c6"></svgicon>
                  <p class="mb-0">Restart</p>
                </b-button>

                <b-button class="rounded-0 py-3" id="sendButton" @click="switchSendValue(true)">
                  <svgicon id="sendIcon" icon="ico_send" color="#0492c6"></svgicon>
                  <p class="mb-0">Send results</p>
                </b-button>
              </b-col>
            </b-row>
          </div>
        </b-form>

        <!-- SEND RESULTS FORMULÄR -->
        <SendForm v-if="showSendForm" @close="switchSendValue(false)" />
      </b-container>
    </form>
  </div>
</template>

<script>
import "../compiled-icons/ico_reset.js";
import "../compiled-icons/ico_send.js";
import SendForm from "./SendForm.vue";

export default {
  name: "calculator",
  components: { SendForm },
  data() {
    return {
      maxLineInput: null,
      winchLineSpeed: 100,
      sheavesReeved: 5,
      maxLine: null,
      craneCost: null,
      laborCost: null,
      otherCost: null,
      cph: null,
      slingLength: null,
      adjustments: null,
      lifts: null,
      timeSavedLift: 0,
      costSavedLift: 0,
      timeSavedDay: 0,
      costSavedDay: 0,
      winch_readonly: false,
      sheaves_readonly: false,
      choice: false,
      ftm: "m",
      maxLabel: "Max line speed (m/min):",
      slingLabel: "Sling length (m):",
      winchLabel: "Winch line speed (m/min):",
      colorMetric: "#0492c6",
      colorImperial: "",
      fontS: "3rem",
      fontSizeTotal: "0.9rem",
      showResult: false,
      showTotal: false,
      showSendForm: false,
      currencyOptions: [
        { value: "USD", text: "USD" },
        { value: "EUR", text: "EUR" },
        { value: "AED", text: "AED" },
        { value: "ARS", text: "ARS" },
        { value: "AUD", text: "AUD" },
        { value: "BR", text: "BR" },
        { value: "CLP", text: "CLP" },
        { value: "CNY", text: "CNY" },
        { value: "COP", text: "COP" },
        { value: "GBP", text: "GBP" },
        { value: "IDR", text: "IDR" },
        { value: "INR", text: "INR" },
        { value: "JPY", text: "JPY" },
        { value: "MAD", text: "MAD" },
        { value: "MXN", text: "MXN" },
        { value: "MYR", text: "MYR" },
        { value: "NOK", text: "NOK" },
        { value: "PHP", text: "PHP" },
        { value: "PLN", text: "PLN" },
        { value: "RUB", text: "RUB" },
        { value: "SEK", text: "SEK" },
        { value: "SGD", text: "SGD" },
        { value: "ZAR", text: "ZAR" }
      ],
      selected: "USD"
    };
  },
  methods: {
    changeSwitchValue: function() {
      if (this.choice) {
        this.choice = false;
        this.ftm = "m";
        this.colorMetric = "#0492c6";
        this.colorImperial = "#ffffff";
      } else {
        this.choice = true;
        this.ftm = "ft";
        this.colorImperial = "#0492c6";
        this.colorMetric = "#ffffff";
      }
      this.maxLabel = "Max line speed (" + this.ftm + "/min):";
      this.slingLabel = "Sling length (" + this.ftm + "):";
      this.winchLabel = "Winch line speed (" + this.ftm + "/min):";

      if (this.craneCost != null) {
        this.calculate();
      }
    },
    resetForm: function() {
      this.maxLineInput = null;
      this.winchLineSpeed = 100;
      this.sheavesReeved = 5;
      this.maxLine = null;
      this.craneCost = null;
      this.laborCost = null;
      this.otherCost = null;
      this.cph = null;
      this.slingLength = null;
      this.adjustments = null;
      this.lifts = null;
      this.timeSavedLift = 0;
      this.costSavedLift = 0;
      this.timeSavedDay = 0;
      this.costSavedDay = 0;
      this.showResult = false;
      this.showTotal = false;
    },

    switchSendValue: function(value) {
      this.showSendForm = value;
    },

    calculate: function() {
      //UTRÄKNING OCH READONLY FÖR CRANE INFO
      var mls;
      if (this.maxLineInput) {
        this.winchLineSpeed = null;
        this.sheavesReeved = null;
        this.sheaves_readonly = true;
        this.winch_readonly = true;
        mls = this.maxLineInput;
      } else {
        this.sheaves_readonly = false;
        this.winch_readonly = false;
        mls = (this.winchLineSpeed / (this.sheavesReeved * 2)).toFixed(2);
      }
      //SLUT UTR & RO CI
      this.maxLine = mls;

      //UTRÄKNING COST INFO
      var clo;
      var oc;
      if (this.otherCost == null || this.otherCost == "") {
        oc = "0";
      } else {
        oc = this.otherCost;
      }

      if (this.craneCost != null || this.laborCost != null) {
        clo = (
          parseFloat(this.craneCost) +
          parseFloat(this.laborCost) +
          parseFloat(oc)
        ).toFixed(2);
      }

      this.cph = clo;
      if (isNaN(this.cph)) {
        this.cph = null;
      }
      //SLUT UTR CI

      //RESULTAT UTRÄKNING
      var dif;
      if (this.ftm == "ft") {
        dif = 3;
      } else if (this.ftm == "m") {
        dif = 1;
      }
      var timeSL = (
        (parseFloat(this.slingLength - dif) / mls) *
        parseFloat(this.adjustments) *
        2
      ).toFixed(2);
      var costSL = (
        ((parseFloat(this.slingLength - dif) / mls) *
          parseFloat(this.adjustments) *
          2 *
          clo) /
        60
      ).toFixed(2);
      var timeSD = ((timeSL * this.lifts) / 60).toFixed(2);
      var costSD = (
        (((parseFloat(this.slingLength - dif) / mls) *
          parseFloat(this.adjustments) *
          2 *
          clo) /
          60) *
        this.lifts
      ).toFixed(2);
      //SLUT RESULTAT UTRÄKNING

      //TEXTSTORLEK
      if (this.cph.length > 22) {
        this.fontSizeTotal = "0.5rem";
      } else if (this.cph.length > 20) {
        this.fontSizeTotal = "0.55rem";
      } else if (this.cph.length > 15) {
        this.fontSizeTotal = "0.65rem";
      } else if (this.cph.length > 13) {
        this.fontSizeTotal = "0.75rem";
      } else if (this.cph.length > 11) {
        this.fontSizeTotal = "0.8rem";
      } else {
        this.fontSizeTotal = "0.9rem";
      }
      if (
        this.slingLength != null ||
        this.adjustments != null ||
        this.lifts != null ||
        this.craneCost != null ||
        this.laborCost != null ||
        this.otherCost != null
      ) {
        var lenghts = [
          timeSL.length,
          costSL.length,
          timeSD.length,
          costSD.length
        ];
        var max = lenghts.reduce(function(a, b) {
          return Math.max(a, b);
        });

        if (max > 20) {
          this.fontS = "0.5rem";
        } else if (max > 15) {
          this.fontS = "0.75rem";
        } else if (max > 10) {
          this.fontS = "1rem";
        } else if (max > 7) {
          this.fontS = "1.5rem";
        } else if (max > 5) {
          this.fontS = "2rem";
        }
        //TESTSTORLEK SLUT

        //VISNING I RESULTAT KOLUMNERNA
        this.timeSavedLift = parseFloat(timeSL);
        this.costSavedLift = parseFloat(costSL);
        this.timeSavedDay = parseFloat(timeSD);
        this.costSavedDay = parseFloat(costSD);
      }

      if (this.craneCost && this.laborCost) {
        this.showTotal = true;
      } else {
        this.showTotal = false;
      }

      if (
        this.winchLineSpeed &&
        this.sheavesReeved &&
        this.craneCost &&
        this.laborCost &&
        this.slingLabel &&
        this.adjustments &&
        this.lifts
      ) {
        this.showResult = true;
      } else if (
        this.maxLineInput &&
        this.craneCost &&
        this.laborCost &&
        this.slingLabel &&
        this.adjustments &&
        this.lifts
      ) {
        this.showResult = true;
      } else {
        this.showResult = false;
      }

      //SLUT VISNING AV RES KOLS
    }
  }
};
</script>

<style>
form {
  color: #ffffff;
  font-size: 0.95rem;
  background-color: #000000;
}

h3,
h4 {
  color: #0492c6;
}

.blue {
  color: #0492c6;
}

.column {
  /* background-color: #313131; */
  background-color: #0c0c0c;
}

.totalCost {
  font-size: 0.9rem;
}

#maxLineInput,
#winchLS,
#sheavesR,
#craneC,
#laborC,
#otherC,
#slingL,
#adj,
#lifts,
#name,
#company,
#country,
#email {
  text-align: center;
  background-color: #3d3d3d;
  color: #ffffff;
  border: none;
}

#maxLineInput:focus,
#winchLS:focus,
#sheavesR:focus,
#craneC:focus,
#laborC:focus,
#otherC:focus,
#slingL:focus,
#adj:focus,
#lifts:focus,
#selectC:focus,
#resetButton:focus,
#sendButton:focus,
#exitButton:focus,
#sendButtonForm:focus,
#name:focus,
#company:focus,
#country:focus,
#email:focus {
  box-shadow: none;
}

#or {
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #3d3d3d;
  line-height: 0.1em;
  margin: 10px 0 20px;
}

#or span {
  background: #0c0c0c;
  padding: 0 10px;
}

#selectC {
  background-color: #3d3d3d;
  border-radius: 0;
  border: 0;
  color: #ffffff;
  /*width: 109.5%;*/
}

#resultColumn {
  height: 8.165rem;
}

#resetButton,
#sendButton {
  background-color: #0c0c0c;
  border: solid #0492c6;
  border-width: 0.1em;
  width: 100%;
}

#resetIcon,
#sendIcon {
  height: 2rem;
}

.switch-component-wrapper {
  display: flex;
}

.switch-wrapper {
  width: 44px;
  min-height: 22px;
  display: flex;
  cursor: pointer;
  border-radius: 22px;
  align-items: center;
  padding: 2px;
  transition: all 0.5s;
  background: #343434;
}

.on {
  justify-content: flex-end;
}

.off {
  justify-content: flex-start;
}

.circle {
  background: #0492c6;
  width: 18px;
  height: 18px;
  border-radius: 18px;
}

.rightAlign {
  text-align: right;
}

#metric,
#imperial {
  font-size: 1rem;
}

#sendButtonForm {
  height: 2.5rem;
  width: 50%;

  background-color: #000000;
  font-size: 1.2em;
  color: #0492c6;

  border-width: 0.2rem;
  border-color: #0492c6;

  text-align: center;
}

@media only screen and (max-width: 770px) {
  .titleResult {
    font-size: 1.4em;
  }
}

@media only screen and (max-width: 576px) {
  #title {
    font-size: 7vw;
    text-align: center;
  }

  form {
    font-size: 1rem;
  }
}
</style>
